<script>
import {mapGetters} from 'vuex'

export default {
  name: 'StandardReportEquipment',

  computed: {
    ...mapGetters('Car', [
      'reportEquipmentById',
    ]),

    carId: {
      get () {
        return this.$route.params.id
      },
    },

    // reportEquipment
    reportEquipment () {
      return this.reportEquipmentById(this.carId)
    },
  },
}
</script>

<template>
  <div class="component-wrapper component-wrapper--standard-report-equipment">
    <!-- report configuration -->
    <div class="report-configuration-notice-wrapper">
      <div class="report-configuration-notice__hd">【特别申明】：</div>
      <div class="report-configuration-notice__bd">
        诺式报告《功能配置》是该车配置的唯一可信版本，其他渠道、人员传递的配置信息仅供参考，如有出入以《功能配置》为准。
      </div>
    </div>
    <!--/ report configuration -->
    <template v-for="(cate, cateIndex) in reportEquipment">
      <template v-if="!cate.is_notes">
        <div
          :key="cateIndex"
          class="category-wrapper">
          <!-- category hd -->
          <div class="category-hd">
            <div class="category-title">{{ cate.title }}</div>
          </div>
          <!--/ category hd -->

          <!-- category bd -->
          <div class="category-bd">
            <template
              v-for="(group, groupIndex) in cate.group"
              :key="groupIndex">
              <div
                class="group-wrapper">
                <template v-if="group.title">
                  <!-- group hd -->
                  <div class="group-hd">
                    <div class="group-title">
                      {{ group.title }}
                    </div>
                  </div>
                  <!--/ group hd -->

                  <!-- group bd -->
                  <div class="group-bd">
                    <template v-for="(option, optionIndex) in group.options">
                      <div
                        v-if="option.configuration"
                        :key="optionIndex"
                        :class="['option-wrapper']">
                        {{
                          option.name === '被测钥匙数'
                            ? option.name + ' ' + option.value
                            : option.name
                        }}
                      </div>
                    </template>
                  </div>
                <!--/ group bd -->
                </template>
                <template v-else>
                  <!-- group bd -->
                  <div class="group-bd group-bd--no-title">
                    <template v-for="(option, optionIndex) in group.options">
                      <div
                        v-if="option.configuration"
                        :key="optionIndex"
                        class="option-wrapper">
                        <template v-if="option.name === '被测钥匙数'">
                          {{ option.name }}：{{ option.value }}
                        </template>
                        <template v-else-if="option.name === '近光灯灯源'">
                          {{ option.name }}：{{ option.value }}
                        </template>
                        <template v-else-if="option.name === '远光灯灯源'">
                          {{ option.name }}：{{ option.value }}
                        </template>
                        <template v-else-if="option.name === '天窗'">
                          <template v-if="option.value !== '未配备'">
                            {{ option.name }}：{{ option.value }}
                          </template>
                          <template v-else>
                            {{ option.name }}
                          </template>
                        </template>
                        <template v-else>
                          {{ option.name }}
                        </template>
                      </div>
                    </template>
                  </div>
                  <!--/ group bd -->
                </template>
              </div>
            </template>
          </div>
          <!--/ category bd -->
        </div>
      </template>
      <template v-else>
        <!-- notes 单独处理 -->
        <template v-if="cate.group.options[0].value">
          <div
            :key="cateIndex"
            class="category-wrapper">
            <div class="category-hd">
              <div class="category-title">
                {{ cate.title }}
              </div>
            </div>
            <div class="category-bd">
              <div class="group-wrapper">
                <div class="group-bd">
                  <div class="note-wrapper">
                    {{ cate.group.options[0].value }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!--/ notes 单独处理 -->
      </template>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.category-wrapper {
  margin-bottom: 15px;

  &:last-child {
    margin-bottom: 0;
  }
}

.category-hd {
  color: #2e5794;
  background: #deeaf6;
  border-bottom: 2px solid #2e77b3;
  margin-bottom: 10px;
}

.category-title {
  padding: 5px 10px;
  box-sizing: border-box;
  font-size: .8rem;
  line-height: 1;
}

.group-wrapper {
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 5px;
}

.group-hd {
  flex: 0 0 70px;
  &:empty {
    display: none;
  }
}

.group-title {
  color: #395f99;
  font-size: .7rem;
  padding-right: 10px;
  &:empty {
    display: none;
  }
}

.group-bd {
  flex: 1;
  display: flex;
  flex-flow: row wrap;
}

.group-bd .option-wrapper {
  flex-basis: calc(33.33% - 10px);
  margin-right: 10px;
  margin-bottom: 5px;
}

.group-bd .option-wrapper:nth-child(3n) {
  margin-right: 0;
}

.group-bd.group-bd--no-title .option-wrapper {
  flex-basis: calc(25% - 10px);
  margin-right: 10px;
}

.group-bd.group-bd--no-title .option-wrapper:nth-child(4n) {
  margin-right: 0;
}

.option-wrapper {
  font-size: .7rem;
  padding: 3px;
  box-sizing: border-box;
  color: #395f99;
  position: relative;
  border: .5px solid #395f99;
  line-height: 1;
}

.option-wrapper.not-available {
  color:#d8d8d8;
  border-color: #d8d8d8;
}

.note-wrapper {
  padding:0 5px;
  color: #212121;
  font-size: .9rem;
  white-space: pre-line;
  word-break: break-all;
  color: #2e5794;
}

.report-configuration-notice-wrapper {
  margin-bottom: 20px;
  display: flex;
  font-size: .75rem;
  color: var(--black-secondary);

  .report-configuration-notice__hd {
    white-space: nowrap;
  }
}

@media (min-width: 640px) {
  .report-configuration-notice-wrapper {
    font-size: .8rem;
  }
}

@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .option-wrapper {
    border: none;
  }

  .option-wrapper::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border: 1px solid #395f99;
    transform: scale(0.5);
    transform-origin: 0 0;
    box-sizing: border-box;
  }
}

@media (min-width: 640px) {
  .category-title {
    font-size: .9rem;
  }

  .group-hd {
    flex: 0 0 100px;
  }

  .group-title {
    font-size: .8rem;
  }

  .option-wrapper {
    padding: 3px 3px;
    font-size:  .8rem;
    letter-spacing: unset;
  }
}

// @media (-webkit-min-device-pixel-ratio: 2),
//   (min-resolution: 192dpi),
//   (prefers-color-scheme: dark) {
//     .option-wrapper {
//       border: none;
//     }
//   }

@media (prefers-color-scheme: dark) {
  .category-hd {
    background: #1A1A1A;
  }

  .category-hd .category-title {
    color: #F0F0F0;
  }

  .group-title {
    color: var(--black-primary);
  }

  .option-wrapper {
    color: #B1B1B1;
    border-color: #3A3A3A;
  }

  .option-wrapper::after {
    border-color: #3A3A3A;
  }

  .category-hd {
    border: none;
  }

  .note-wrapper {
    color: #F0F0F0;
  }
}
</style>
